export default __webpack_public_path__ + "static/media/logo-black.8eb6094e.png";